<template>
  <div class="paymant-choice">
    <div class="card p-grid" style="padding-bottom: 50px">
        <div class="p-col-12">
            <span class="title">Complete payment: BITCOIN</span>
        </div>
        <div class="p-col-12" style="padding-top: 30px; padding-bottom: 60px">
            <span class="detail">Your purchase will be approved once the payment is processed</span>
        </div>
        
        <div class="p-col-3">
            <img :src="payment.qrcode_url" style="display: block;" />
        </div>
        <div class="p-col-9">
            <div class="p-grid" style="padding-top: 50px">
                <div class="p-col-8">
                    <div>
                        <label>Your Client ID: </label>
                        <span>{{ payment.user_id }}</span>
                    </div>
                </div>
                <div class="p-col-4">
                    <div>
                        <label>Package: </label>
                        <span>{{ payment.package_name }}</span>
                    </div>
                </div>

                <div class="p-col-8">
                    <div>
                        <label>Payment amount: </label>
                        <span>{{ payment.btc_amount }} {{ payment.currency }}</span>
                    </div>
                    <div>
                        <label>Amount remaining: </label>
                        <span>{{ payment.btc_amount_remaining }} {{ payment.currency }}</span>
                    </div>
                </div>
                <div class="p-col-4">
                </div>

                <div class="p-col-8">
                    <div>
                        <label>Address: </label>
                        <span>{{ payment.wallet }}</span>
                    </div>
                </div>
                <div class="p-col-4">
                    <div>
                        <countdown :time="payment.deadline">
                            <template slot-scope="props"><label>Time left: </label>{{ props.hours }}:{{ props.minutes }}</template>
                        </countdown>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";
import CoinPaymentsService from "../../service/CoinPaymentsService";

export default {
  data() {
    return {
      payment: {
          purchase_id: '',
          user_id: '',
          currency: '',
          btc_amount: '',
          btc_amount_remaining: '',
          wallet: '',
          package_name: '',
          deadline: '',
      },
    };
  },
  components: {
  },

  mounted() {

  },
  async created() {
    this.$store.commit('setPageTitle', { pageTitle: 'Confirm Payment' });
    this.coinPaymentsService = new CoinPaymentsService();
    if (this.$route.query.purchase_id) {
        this.payment.purchase_id = this.$route.query.purchase_id
        const transaction = await this.coinPaymentsService.getTransaction(this.payment.purchase_id)
        this.payment = {
            purchase_id: this.$route.query.purchase_id,
            user_id: this.$store.state.currentUser.id,
            qrcode_url: transaction.qrcode_url,
            currency: transaction.currency,
            btc_amount: transaction.amount,
            btc_amount_remaining: transaction.btc_amount_remaining,
            wallet: transaction.wallet,
            package_name: transaction.package_name,
            deadline: 60 * 60 * 1000,
        }
        console.log(this.payment);
    }
  },
  methods: {
    
  },
};
</script>

<style scoped>
label {
    font-weight: 600;
}
</style>